import React from 'react'
import './Footer.css'

function Footer () {
  return (
    <footer className="footer">
      <p>
          Code with ❤️ by <a href="https://twitter.com/jsifontez_" target="_blank" rel="noreferrer">@jsifontez</a>
        </p>
        <p>
          Commits are welcome on <a href="https://github.com/Jsifontez/country-quiz-devchallenge" target="_blank" rel="noreferrer">GitHub</a>
        </p>
    </footer>
  )
}

export default Footer
